import { render, staticRenderFns } from "./seckillSku.vue?vue&type=template&id=6867353a&scoped=true&"
import script from "./seckillSku.vue?vue&type=script&lang=js&"
export * from "./seckillSku.vue?vue&type=script&lang=js&"
import style0 from "./seckillSku.vue?vue&type=style&index=0&id=6867353a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867353a",
  null
  
)

export default component.exports